import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numberOnly]',
  standalone: true
})
export class NumberOnlyDirective {
  private numberPattern = '^[0-9]+$';

  constructor(private elRef: ElementRef) {}

  // Block on keypress
  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return new RegExp(this.numberPattern).test(event.key);
  }

  // Block on copy/paste
  @HostListener('paste', ['$event']) blockPaste(event: ClipboardEvent) {
    this.validateFields(event);
  }

  private validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData
      .getData('text/plain')
      .replace(/[^0-9]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
